var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"container",style:({ height: _vm.windowHeight + 'px' })},[_c('van-address-edit',{attrs:{"area-list":_vm.areaList,"show-postal":"","save-button-text":"确定","area-columns-placeholder":['请选择', '请选择', '请选择']},on:{"save":_vm.addAddress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }